export default __webpack_public_path__ + "static/media/man_people_person_user_icon.cf1c7862.svg";